export const useCharCount = (category?: string, level?: string) => {
  const categoryChars = category ? category.length : 0;
  const levelChars = level ? level.length : 0;
  const space = level && category ? 1 : 0;

  const totalChars = categoryChars + levelChars + space;

  return { totalChars };
};
